import ih from 'immutability-helper';
import createPaginatedListReducerWithNamedType from 'store/hoReducers/paginatedList/reducer';
import { PURGE_ACTIONS } from 'store/services/project/actionTypes';
import initialState from './initialState';
import * as types from './actionTypes';

const reducerHandlers = (state = initialState, action = {}) => ({
  [PURGE_ACTIONS]: () => ({
    ...state,
    show: {
      ...state.show,
      data: !action.payload.data.rules.includes(state.show.data.id)
        ? state.show.data
        : {},
    },
  }),
  [types.SELECT_RULE]: () =>
    ih(state, {
      show: {
        isLoading: {
          $set: true,
        },
        data: {
          $set: action.payload.item,
        },
      },
    }),
  [types.PARTIAL_UPDATE_RULE_REQUEST]: () => ({
    ...state,
    partialUpdate: {
      ...state.partialUpdate,
      isLoading: true,
    },
  }),
  [types.PARTIAL_UPDATE_RULE_SUCCESS]: () => ({
    ...state,
    partialUpdate: {
      ...state.partialUpdate,
      isLoading: false,
    },
  }),
  [types.PARTIAL_UPDATE_RULE_ERROR]: () => ({
    ...state,
    partialUpdate: {
      ...state.partialUpdate,
      isLoading: false,
      error: action.payload.error,
    },
  }),
  [types.REORDER_RULE_REQUEST]: () => ({
    ...state,
    reorder: {
      ...state.reorder,
      isLoading: true,
    },
  }),
  [types.REORDER_RULE_SUCCESS]: () => ({
    ...state,
    reorder: {
      ...state.reorder,
      isLoading: false,
    },
  }),
  [types.REORDER_RULE_ERROR]: () => ({
    ...state,
    reorder: {
      ...state.reorder,
      isLoading: false,
      error: action.payload.error,
    },
  }),
});

export default createPaginatedListReducerWithNamedType(
  'RULE',
  initialState,
  reducerHandlers,
);
